
import { computed, defineComponent, onMounted, ref } from "vue";
import { StepperComponent } from "@/assets/ts/components";
import { useForm } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import Step1 from "@/components/wizard/steps/Step1.vue";
import Step2 from "@/components/wizard/steps/Step2.vue";
import Step3 from "@/components/wizard/steps/Step3.vue";
import Step4 from "@/components/wizard/steps/Step4.vue";
import Step5 from "@/components/wizard/steps/Step5.vue";
import Step6 from "@/components/wizard/steps/Step6.vue";
import Step7 from "@/components/wizard/steps/Step7.vue";
import Step8 from "@/components/wizard/steps/Step8.vue";
import ReportReady from "@/components/wizard/steps/ReportReady.vue";
import ReportReadyCtms from "@/components/wizard/steps/ReportReadyCtms.vue";
import MedicalRecordStep from "@/components/wizard/steps/MedicalRecordStep.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import MBloader from "@/components/MBLoader.vue";
import useLocale from "@/core/common/useLocale";

interface IStep1 {
  cancer_type: string;
}

interface IStep2 {
  gender: string;
}

interface IStep3 {
  birthdate: string;
}

interface IStep4 {
  fullname: string;
  first_name: string;
  last_name: string;
}
interface IStep5 {
  patient_s_email: string;
}
interface IStep6 {
  patient_s_phone: string;
  country_code: string;
}
interface IStep7 {
  zip: string;
}
interface CreateAccount
  extends IStep1,
    IStep2,
    IStep3,
    IStep4,
    IStep5,
    IStep6,
    IStep7 {}

export default defineComponent({
  name: "kt-horizontal-wizard",
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8,
    ReportReady,
    ReportReadyCtms,
    MedicalRecordStep,
    MBloader,
  },
  inject: ["ismobile"],

  setup: function (props, { emit }) {
    const store = useStore();
    const { t, currentLocale } = useLocale();

    const current_phone = ref("");
    const nextshow = ref(true);
    const submitshow = ref(false);
    const _stepperObj = ref<StepperComponent | null>(null);
    const horizontalWizardRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);
    let trial_num = ref("0");

    const email_field = ref();
    let f = true;
    let ctmstab = ref(false);
    let vtbtab = ref(false);
    const isLoaded = ref<boolean>(false);

    const phone_field = ref();
    const zip_field = ref();
    const gender_field = ref();
    const date_of_birth_field = ref();
    const first_name_field = ref();
    const last_name_field = ref();

    const formData = ref<CreateAccount>({
      cancer_type: "",
      gender: "",
      birthdate: "",
      fullname: "",
      patient_s_email: "",
      patient_s_phone: "",
      zip: "",
      first_name: "",
      last_name: "",
      country_code: "",
    });
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        horizontalWizardRef.value as HTMLElement
      );
      setCurrentPageBreadcrumbs("Onboarding", ["Pages", "Wizards"]);
    });

    const getPatientValues = () => {
      isLoaded.value = false;
      const pv_raw = store.getters.getPatientValues;
      const process = store.getters.getPatientProcesses;

      ctmstab.value = process.ReleaseCTMSReportPatient ? true : false;
      vtbtab.value = process.ReleaseVTBReportPatient ? true : false;

      formData.value.cancer_type = pv_raw.cancer_type;
      formData.value.gender = pv_raw.sex;
      if (pv_raw.first_name != undefined) {
        formData.value.fullname = pv_raw.first_name + " " + pv_raw.last_name;
        first_name_field.value = pv_raw.first_name;
        last_name_field.value = pv_raw.last_name;
      }
      formData.value.patient_s_email = pv_raw.patient_s_email;
      email_field.value = pv_raw.patient_s_email;

      formData.value.patient_s_phone = pv_raw.patient_s_phone;

      current_phone.value = pv_raw.patient_s_phone;
      phone_field.value = pv_raw.patient_s_phone;

      formData.value.zip = pv_raw.zip;
      zip_field.value = pv_raw.zip;

      formData.value.birthdate = pv_raw.birthdate;
      date_of_birth_field.value = pv_raw.birthdate;

      if (currentLocale.value === "en") {
        formData.value.birthdate = pv_raw.birthdate;
      } else {
        const [month, day, year] = pv_raw.birthdate.split("/");
        formData.value.birthdate = [day, month, year].join("/");
      }

      resetForm({
        values: {
          ...formData.value,
        },
      });
      for (let item in formData.value) {
        if (
          !formData.value[item] &&
          item != "first_name" &&
          item != "last_name" &&
          item != "country_code"
        ) {
          f = false;
        }
      }

      if (pv_raw.ctms_report_count && ctmstab.value && _stepperObj.value) {
        trial_num.value = pv_raw.potential_selected_trial_count;
        _stepperObj.value.goto(11);
        nextshow.value = false;
        submitshow.value = false;
      } else if (
        (pv_raw.ctms_report_count == 0 ||
          pv_raw.ctms_report_count == undefined) &&
        pv_raw.consent_sign == 1 &&
        _stepperObj.value
      ) {
        trial_num.value = pv_raw.potential_selected_trial_count;
        _stepperObj.value.goto(10);
        nextshow.value = false;
        submitshow.value = false;
      } else if (pv_raw.widget_report_count && _stepperObj.value) {
        trial_num.value = pv_raw.potential_selected_trial_count;
        _stepperObj.value.goto(9);
        nextshow.value = false;
        submitshow.value = false;
      } else if (
        f &&
        !pv_raw.widget_report_count &&
        !pv_raw.widget_report_count &&
        _stepperObj.value
      ) {
        _stepperObj.value.goto(8);
      }
      isLoaded.value = true;
    };

    const createAccountSchema = [
      Yup.object({
        cancer_type: Yup.string()
          .required(t("Cancer Type is a required field"))
          .label(t("Cancer Type")),
      }),
      Yup.object({
        gender: Yup.string()
          .required(t("Gender is a required field"))
          .label(t("Gender")),
      }),
      Yup.object({
        birthdate: Yup.string()
          .required(t("Birthdate is a required field"))
          .label(t("Birthdate")),
      }),
      Yup.object({
        fullname: Yup.string()
          .matches(
            /^([^0-9+-]*)$/,
            t("Only alphabets are allowed for this field")
          )
          .required(t("Full name is a required field"))
          .label(t("Full name")),
      }),
      Yup.object({
        patient_s_email: Yup.string()
          .required(t("Email is a required field"))
          .label(t("Email")),
      }),
      Yup.object({
        patient_s_phone: Yup.string()
          .matches(/^[0-9\- +()]{0,20}$/)
          .required(t("Phone Number is a required field"))
          .label(t("Phone Number")),
        country_code: Yup.string(),
      }),
      Yup.object({
        zip: Yup.string()
          .required(t("Zip is a required field"))
          .label(t("Zip")),
      }),
    ];

    const currentSchema = computed(() => {
      return createAccountSchema[currentStepIndex.value];
    });

    const { resetForm, handleSubmit } = useForm<
      IStep1 | IStep2 | IStep3 | IStep4 | IStep5 | IStep6 | IStep7
    >({
      validationSchema: currentSchema,
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    resetForm({
      values: {
        ...formData.value,
      },
    });

    const handleStep = handleSubmit(async (values, { resetForm }) => {
      currentStepIndex.value++;

      formData.value = {
        ...formData.value,
        ...values,
      };

      if (currentStepIndex.value == 6) {
        nextshow.value = false;
        submitshow.value = true;
      } else if (currentStepIndex.value == 3) {
        date_of_birth_field.value = formData.value.birthdate;
      } else if (currentStepIndex.value == 2) {
        gender_field.value = formData.value.gender;
      } else if (currentStepIndex.value == 4) {
        phone_field.value = formData.value.patient_s_phone;
      } else if (currentStepIndex.value == 7) {
        formData.value = {
          ...formData.value,
          ...values,
        };
        if (formData.value.fullname) {
          const splitOnSpace = formData.value.fullname.split(" ");
          const clon = JSON.parse(JSON.stringify(values));
          clon.first_name = splitOnSpace[0];
          clon.last_name = splitOnSpace[1];
          values = clon;
        }

        if (formData.value.birthdate && currentLocale.value !== "en") {
          const clon = JSON.parse(JSON.stringify(values));
          const [day, month, year] = formData.value.birthdate.split("/");
          clon.birthdate = [month, day, year].join("/");
          values = clon;
        }

        await store.dispatch(Actions.UPDATE_PATIENT_VALUE, values);
        const res = store.getters.getResponse;
        if (res.success) {
          localStorage.setItem("home_form", "1");
          emit("refreshData");
          //window.location.reload();
        } else {
          let mes = t("Please try again later.");
          if (res.message) {
            mes = res.message;
          }
          Swal.fire({
            text: t(mes),
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: t("Try again!"),
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      }
      if (!_stepperObj.value) {
        return;
      }
      resetForm({
        values: {
          ...formData.value,
          ...values,
        },
      });
      _stepperObj.value.goNext();
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    return {
      horizontalWizardRef,
      previousStep,
      handleStep,
      totalSteps,
      currentStepIndex,
      nextshow,
      submitshow,
      isLoaded,
      trial_num,
      getPatientValues,
      current_phone,
      zip_field,
      gender_field,
      date_of_birth_field,
      first_name_field,
      last_name_field,
      phone_field,
      email_field,
      currentLocale,
    };
  },
});
